import apiPaths from '../api-paths';

export default {
  indexRepresentatives({ query }) {
    return axios.get(`${ apiPaths.STAFF }/partner-staff-board-members/representatives${ query }`);
  },
  syncRepresentatives({ representatives, crmOriginal }) {
    return axios.post(`${ apiPaths.STAFF }/partner-staff-board-members/representatives`, { crmOriginal, representatives });
  },
  index({ query }) {
    return axios.get(`${ apiPaths.STAFF }/partner-staff-board-members${ query }`);
  },
  show({ id }) {
    return axios.get(`${ apiPaths.STAFF }/partner-staff-board-members/${ id }`);
  },
  store({ data }) {
    return axios.post(`${ apiPaths.STAFF }/partner-staff-board-members`, { partnerstaffboardmember: data });
  },
  update({ data }) {
    return axios.put(`${ apiPaths.STAFF }/partner-staff-board-members/${ data.id }`, { partnerstaffboardmember: data });
  },
  downstream: {
    indexRepresentatives({ query }) {
      return axios.get(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staff-board-members/representatives${ query }`);
    },
    syncRepresentatives({ representatives, crmOriginal }) {
      return axios.post(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staff-board-members/representatives`, { crmOriginal, representatives });
    },
    index({ query }) {
      return axios.get(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staff-board-members${ query }`);
    },
    show({ id, query }) {
      return axios.get(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staff-board-members/${ id }${ query }`);
    },
    store({ data, crmOriginal }) {
      return axios.post(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staff-board-members`, { partnerstaffboardmember: data, crmOriginal });
    },
    update({ data, crmOriginal }) {
      return axios.put(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staff-board-members/${ data.id }`, {
        partnerstaffboardmember: data,
        crmOriginal,
      });
    },
    destroy({ id, query }) {
      return axios.delete(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staff-board-members/${ id }${ query }`);
    },
  },
};
